import { CustomError } from "ts-custom-error";
export class MastoWebSocketError extends CustomError {
    constructor(message, options) {
        super(message, options);
        this.message = message;
    }
}
